import { Action, initialState, State } from "store/store";

export const setIsScrolling = (
  state: State = initialState,
  { data }: Action
): State => {
  return {
    ...state,
    isScrolling: data.isScrolling,
  };
};